<template>
  <div class="control ">
    <div class="title">
      <div class="tit">听写工具</div>
      <div class="btn" @click="backhome"></div>
    </div>
    <div class="controlwrap clr">
      <div class="route dictionroute" :style="{height: height+'px'}">

        <div class="dictop" :class="{'hide': hideBlon}">

          <div class="selectOperation clr">
            <div class="select fl">
              <div class="tits" @click="bookBlon = !bookBlon">{{selectedbook.bookname}}</div>
              <div class="selectlist" v-if="bookBlon">
                <ul>
                  <li v-for="(item,index) in booksinfo" :key="index">
                    <div class="list" @click="bookBlon = !bookBlon,selectedbook=item,getUnitsInfo(item.bookid)">{{item.bookname}}</div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="select fl">
              <div class="tits units" @click="unitBlon = !unitBlon">{{selectedunit.unitid==0?'全书':'UNIT '+selectedunit.unitid}}</div>
              <div class="selectlist" v-if="unitBlon">
                <ul>
                  <li>
                    <div class="list" @click="unitBlon = !unitBlon,selectedunit={unitid:0},getWordsInfo(selectedbook.bookid,0)">全书</div>
                  </li>
                  <li v-for="(item,index) in unitsinfo" :key="index">
                    <div class="list" @click="unitBlon = !unitBlon,selectedunit=item,getWordsInfo(selectedbook.bookid,item.unitid)">UNIT {{item.unitid}}</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="dictionroutecenter">
            <div :class="['list',selectedmode=='英文'?'on':'']" @click="selectedmode='英文'">英文</div>
            <div :class="['list',selectedmode=='中文'?'on':'']" @click="selectedmode='中文'">中文</div>
            <div :class="['list',selectedmode=='英中'?'on':'']" @click="selectedmode='英中'">英中</div>
            <div :class="['list',selectedmode=='中英'?'on':'']" @click="selectedmode='中英'">中英</div>
          </div>
          <div class="dictionroutecenter xdictionroutecenter">
            <div :class="['list',selectedtimes==1?'on':'']" @click="selectedtimes=1">1次</div>
            <div :class="['list',selectedtimes==2?'on':'']" @click="selectedtimes=2">2次</div>
            <div :class="['list',selectedtimes==3?'on':'']" @click="selectedtimes=3">3次</div>
            <div :class="['list',selectedtimes==4?'on':'']" @click="selectedtimes=4">4次</div>
            <div :class="['list',selectedtimes==5?'on':'']" @click="selectedtimes=5">5次</div>
          </div>
          <p class="tit">请准备好纸笔，然后点击确定</p>

        </div>

        <div class="dicend" :class="{'hide': !hideBlon}">
          <p class="p1">正在听写...</p>
          <p class="p2">{{selectedbook.bookname}} / UNIT {{selectedunit.unitid}}</p>
          <p class="p3">{{selectedmode}} / {{selectedtimes}}次</p>
          <p class="p4">{{parseInt(currentindex/selectedtimes)+1}}/{{wordsinfo.length}}</p>
        </div>

        <div class="btnlists">
          <div class="btn fl" @click="dictationstop()">取消</div>
          <div class="btn on" v-if="!hideBlon" @click="dictationbegin()">确定</div>
          <div :class="['btn fl',isplaying?'suspend':'play']" v-else @click="dictationplay()">{{isplaying?"暂停":"继续"}}</div>
        </div>
      </div>
    </div>
    <div class="mask" v-if="bookBlon || unitBlon"></div>
  </div>
</template>
<script>
import { getbooksinfo, getunitsinfo, getwordsinfo, getspeehbytxt } from '../../api/base'
export default {
  data() {
    return {
      height: null,
      hideBlon: false,
      bookBlon: false,
      unitBlon: false,
      booksinfo: [],
      unitsinfo: [],
      wordsinfo: [],
      selectedbook: { bookid: '', unitid: '' },
      selectedunit: { unitid: 0 },
      selectedmode: "英文",
      selectedtimes: 1,
      dictationword: [],
      currentindex: 0,
      isplaying: true,
      timer: null,
    };
  },
  created() {
    this.$router.push({ path: '/dictationtools' })
  },
  methods: {
    backhome() {
      this.$router.push({ path: '/index' })
    },
    //加载页面时调用
    getBooksInfo() {
      var that = this;
      getbooksinfo({
         userid: that.utils.storageGet("userinfo").userid,
       // userid: "20ss3915",
      }).then(res => {
        that.booksinfo = [...res];
        that.selectedbook = that.booksinfo[0];
        that.getUnitsInfo(that.selectedbook.bookid);
      });
    },
    //选择书本时调用
    getUnitsInfo(bookid) {
      var that = this;
      getunitsinfo({
        bookid: bookid,
      }).then(res => {
        that.unitsinfo = [...res];
        that.getWordsInfo(that.selectedbook.bookid, that.selectedunit.unitid);
      });
    },
    //选择单元时调用
    getWordsInfo(bookid, unitid) {
      var that = this;
      getwordsinfo({
        bookid: bookid,
        unitid: unitid,
      }).then(res => {
        that.wordsinfo = [...res];
      });
    },
    //确定按钮
    dictationbegin() {
      var that = this;
      that.hideBlon = true;
      that.isplaying = false;
      that.dictationword = [];
      for (let item of that.wordsinfo) {
        for (let i = 0; i < that.selectedtimes; i++) {
          that.dictationword.push(item);
        }
      }
      that.dictationplay();
    },
    //取消按钮
    dictationstop() {
      var that = this;
      if (that.hideBlon) {
        clearInterval(that.timer);
        that.currentindex = 0;
        that.hideBlon = false;
      } else {
        that.backhome();
      }
    },
    //暂停或继续
    dictationplay() {
      var that = this;
      if (that.isplaying) {
        clearInterval(that.timer);
        that.isplaying = false;
      } else {
        that.isplaying = true;

        setTimeout(() => {
          that.playsound();
        }, 2e3);
        that.timer = setInterval(() => {
          that.currentindex++;
          that.playsound();
        }, 5000);
      }
    },
    playsound() {
      var that = this;
      if (that.currentindex == that.dictationword.length) {
        clearInterval(that.timer);
        that.currentindex = 0;
        that.isplaying = false;
        that.hideBlon = false;
        return;
      }
      let wordinfo = that.dictationword[that.currentindex];
      switch (that.selectedmode) {
        case "英文":
          that.utils.playAudio(`//static.cizhuangyuan.com/static/mp3/usa/${wordinfo.word[0].toLowerCase()}/${wordinfo.word}.mp3`);
          break;
        case "中文":
          that.getspeech(wordinfo.meaning);
          break;
        case "英中":
          that.utils.playAudio(`//static.cizhuangyuan.com/static/mp3/usa/${wordinfo.word[0].toLowerCase()}/${wordinfo.word}.mp3`);
          setTimeout(function () { that.getspeech(wordinfo.meaning); }, 1000);
          break;
        case "中英":
          that.getspeech(wordinfo.meaning);
          setTimeout(function () {
            that.utils.playAudio(`//static.cizhuangyuan.com/static/mp3/usa/${wordinfo.word[0].toLowerCase()}/${wordinfo.word}.mp3`);
          }, 1000);
          break;
      }
    },
    //tts
    getspeech(playtxt) {
      var that = this;
      getspeehbytxt({
        txt: playtxt,
        voiceType: 1,
        rate: -3,
        ischina: 1
      }).then(res => {
        that.utils.playAudio(`https://sys.cizhuangyuan.com/tts/tempmp3/` + res);
      });
    }
  },
  mounted() {
    var that = this;
    that.height = window.innerHeight - (230 * that.utils.per());
    that.getBooksInfo();
  },
  destroyed() {
    var that = this;
    clearInterval(that.timer);
    that.timer = null;
  },
  components: {

  },
}
</script>
<style scoped>
</style>
